import React, { useState } from 'react';

const RunForm = ({ existingNames, onSubmit, isDevMode, onSeedTestData, isExpired }) => {
  const [name, setName] = useState('');
  const [kilometers, setKilometers] = useState(0);
  const [date, setDate] = useState('');
  const [image, setImage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (kilometers <= 0 || kilometers > 100) {
      alert('Bitte gib eine gültige Kilometerzahl ein (0-100km)');
      return;
    }

    if (!name.trim()) {
      alert('Bitte gib deinen Namen ein');
      return;
    }

    if (image && image.size > 5 * 1024 * 1024) {
      alert('Das Bild darf maximal 5MB groß sein');
      return;
    }

    try {
      await onSubmit({ name, kilometers: Number(kilometers), date }, image);
      setKilometers(0);
      setDate('');
      setImage(null);
      setName('');
    } catch (error) {
      console.error('Fehler beim Speichern:', error);
      alert('Es ist ein Fehler aufgetreten. Bitte später erneut versuchen.');
    }
  };

  if (isExpired) {
    return (
      <div className="run-form" style={{ textAlign: 'center', color: '#666' }}>
        <h2 style={{ marginTop: 0, color: 'var(--primary)' }}>Neue Laufeinheit</h2>
        <p style={{ fontSize: '1.1rem' }}>Die Eingabe von Läufen ist geschlossen.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="run-form">
      <h2 style={{ marginTop: 0, color: 'var(--primary)' }}>Neue Laufeinheit</h2>

      {isDevMode && (
        <button
          type="button"
          onClick={onSeedTestData}
          style={{
            backgroundColor: '#ff9800',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '600',
            marginBottom: '20px',
            width: '100%'
          }}
        >
          🧪 Seed Test Data (Runners near milestones)
        </button>
      )}

      <div>
        <label htmlFor="run-name">Name</label>
        <div className="name-input-container">
          <input
            id="run-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="Dein Name"
            list="existing-names"
          />
          <datalist id="existing-names">
            {existingNames.map(existingName => (
              <option key={existingName} value={existingName} />
            ))}
          </datalist>
        </div>
      </div>

      <div>
        <label htmlFor="run-km">Kilometer</label>
        <input
          id="run-km"
          type="number"
          step="0.01"
          value={kilometers}
          onChange={(e) => setKilometers(e.target.value)}
          required
          placeholder="z.B. 5.5"
        />
      </div>

      <div>
        <label htmlFor="run-date">Datum</label>
        <input
          id="run-date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required
        />
      </div>

      <div>
        <label htmlFor="run-photo">Foto hochladen</label>
        <input
          id="run-photo"
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
          required
        />
      </div>

      <button type="submit">Lauf speichern</button>
    </form>
  );
};

export default RunForm;
